import _ from 'lodash';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import VirtualizedSelect from 'react-virtualized-select';

import DeleteButton from 'common/components/delete-button';
import HFMDragDropContext from 'common/components/hfm-drag-drop-context';

const filterSelectedArtists = (selectedArtists = [], artistList = []) => {
	return artistList.filter((artist) => {
		return selectedArtists.map(({ _id }) => _id).indexOf(artist._id) === -1;
	});
};


@inject('artistStore')
@observer
class ArtistListItemButtons extends React.Component {
	state = {};

	render () {

		return this.state.editMode ? this.renderVirtualizedSelect() : this.renderButtons();
	}

	renderButtons () {
		const { artist } = this.props;

		return (
			<div className="grid-x">
				<div className="cell shrink">
					<button
						className="button secondary clear padding-left-0"
						onClick={ this.onClick } data-ta="editFeaturedArtist"
					>
						<span className="fas fa-pencil"></span>
					</button>
				</div>
				<div className="cell shrink">
					<DeleteButton
						orientation="right"
						warningText={ `Really remove ${ artist.name }?` }
						onConfirmClick={ this.onConfirmClick }
					>
						<button className="button alert clear padding-left-0">
							<span className="fas fa-trash"></span>
						</button>
					</DeleteButton>
				</div>
			</div>
		);
	}

	renderVirtualizedSelect () {
		const { artistStore } = this.props;
		const featuredArtists = artistStore.getFeaturedArtists();
		const featuredIDs = featuredArtists.map(({ _id }) => _id);
		const alphabeticArtists = artistStore.alphabeticArtists
			.filter(({ _id }) => featuredIDs.indexOf(_id) === -1);

		return (
			<div className="grid-x">
				<div className="cell small-12" style={{padding: '.5rem 0'}}>
					<VirtualizedSelect
						simpleValue
						clearable
						searchable
						ref="artistSelect"
						name="select-city"
						options={ alphabeticArtists }
						value={ this.state.selectValue }
						onChange={ this.onChange }
						labelKey="name"
						valueKey="_id"
					/>
				</div>
			</div>
		);
	}

	@autobind
	onClick () {
		this.setState({
			editMode: true
		});
	}

	@autobind
	onChange (artistID) {
		const { artistStore, artist } = this.props;

		artistStore
			.swapFeaturedPosition({
				removeArtist: artist,
				addArtist: artistStore.getArtistByID(artistID)
			});

		this.setState({
			editMode: false
		});
	}

	@autobind
	onConfirmClick () {
		const { artistStore, artist } = this.props;
		artistStore.removeFeaturedArtist(artist);
	}
}

class ArtistListItem extends React.Component {
	render () {
		const { artist, featuredArtists } = this.props;

		return (
			<div className="cell shrink" data-ta="featuredArtistsItem">
				<div className="grid-x" data-ta={ artist.name }>
					<div className="cell shrink">
						<div
							className="image medium"
							style={{
								border: 'solid 1px #999',
								backgroundImage: `url("${artistStore.getArtistImage(artist)}")`
							}}
						>
						</div>
					</div>
				</div>

				<ArtistListItemButtons artist={ artist } />
			</div>
		);
	}
}

@inject('artistStore')
@observer
class ArtistSelector extends React.Component {
	state = {
		selectValue: ''
	};

	@autobind
	onChange (artistID) {
		const { artistStore } = this.props;

		this.setState({
			selectValue: artistID
		});

		artistStore.addFeaturedArtist(artistStore.getArtistByID(artistID));
	}

	render() {
		const featuredArtists = this.props.artistStore.getFeaturedArtists();

		return (
			<div className="grid-x grid-padding-x grid-padding-y" data-ta="featuredArtistsContainer">
				<div className="cell small-12 padding-top-0 padding-left-1">
					<h3 data-ta="featuredArtistsHeader">Manage Featured Artists</h3>
				</div>

				{
					featuredArtists.map((artist) => (
						<ArtistListItem
							key={ artist._id }
							artist={ artist }
							featuredArtists={ featuredArtists }
						/>
					))
				}

				{ this.renderVirtualizedSelect() }
			</div>
		);
	}

	renderVirtualizedSelect () {
		const featuredArtists = this.props.artistStore.getFeaturedArtists();

		if (featuredArtists.length > 14) {

			return null;
		}

		const { artistStore } = this.props;
		const featuredIDs = featuredArtists.map(({ _id }) => _id);
		const alphabeticArtists = artistStore.alphabeticArtists
			.filter(({ _id }) => featuredIDs.indexOf(_id) === -1);

		return (
			<div className="cell small-12 padding-1" data-ta="featuredArtistsSelect">
				<h5>Add a Featured Artist</h5>

				<VirtualizedSelect
					simpleValue
					clearable
					searchable
					ref="artistSelect"
					name="featured-artists-select"
					options={ alphabeticArtists }
					value={ this.state.selectValue }
					onChange={ this.onChange }
					labelKey="name"
					valueKey="_id"
				/>
			</div>
		);
	}


}

export default ArtistSelector;
